import Maker from "../pages/Maker";
import { useDispatch, useSelector } from "react-redux";
import useLoginCheck from "../hooks/useLoginCheck";
import useDatabase from "../hooks/useDatabase";

const MakerContainer = () => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useLoginCheck(dispatch);
  useDatabase(dispatch, user.userId);

  return <Maker />;
};

export default MakerContainer;
